import {AppNotification} from 'components/Notification';
import {SnackbarProvider, SnackbarProviderProps} from 'notistack';
import React from 'react';

interface SnackProviderConfigProps extends SnackbarProviderProps {
    children?: React.ReactNode;
}

export const SnackProviderConfig: React.FC<SnackProviderConfigProps> = ({children, ...props}) => {
    return (
        <SnackbarProvider
            Components={{
                info: AppNotification,
            }}
            {...props}
        >
            {children}
        </SnackbarProvider>
    );
};

export default SnackProviderConfig;
